import { useFormik } from 'formik';
import { Form } from 'react-bootstrap';
import * as Yup from 'yup';
import { Modal, TextInput } from '@pmi/dsm-react';
import styles from './editAccountNameModal.module.scss';
import { useUpdateAccountNameMutation } from './apiSlice';
import { toastWithAnalytics } from '../../../../shared/analytics';
import AccountDto from '../../../../shared/models/AccountModel';

interface EditAgreementNameModalProps {
  account: AccountDto;
  onCancel?: () => void;
}

export default function EditAccountNameModal({
  account,
  onCancel = () => {},
}: EditAgreementNameModalProps) {
  const [updateAccountName, updateAccountNameStatus] =
    useUpdateAccountNameMutation();

  const initialData = {
    accountName: account.name,
  };
  const validationSchema = Yup.object().shape({
    accountName: Yup.string().max(40, 'Account Name must be max 40 characters'),
  });

  const onSave = async (model: { accountName: string }) => {
    updateAccountName({
      accountId: account.id,
      name: model.accountName,
    })
      .unwrap()
      .then(() => {
        toastWithAnalytics(`Account Name updated successfully`, 'success');
        onCancel();
      })
      .catch((ex) => {
        toastWithAnalytics(
          `Error while updating Account !! ${ex?.data?.detail}.`,
          'danger',
        );
      });
  };

  const onCancelHandler = () => {
    onCancel();
  };

  const formik = useFormik({
    initialValues: initialData,
    validateOnChange: true,
    validateOnBlur: true,
    onSubmit: (values: { accountName: string }) => {
      onSave(values);
    },
    validationSchema,
  });

  const onUpdateClick = () => {
    formik.submitForm();
  };

  return (
    <Modal
      show
      customClassName="modalBody100"
      onClose={onCancelHandler}
      buttons={[
        {
          titleText: 'Cancel',
          variant: 'outline-secondary',
          onClick: onCancelHandler,
          disabled: updateAccountNameStatus.isLoading,
        },
        {
          titleText: 'Save Changes',
          variant: 'primary',
          onClick: onUpdateClick,
          disabled: updateAccountNameStatus.isLoading,
        },
      ]}
    >
      <div className="d-flex flex-column">
        <div className={`mb-3 ${styles.titleBlock}`}>
          <h5 className="mb-2">Edit Account Name</h5>
        </div>
        <Form className="mb-4">
          <div className="row gy-3 row-cols-1 mb-2">
            <div className="col" data-testid="deal_name_container_testid">
              <Form.Group
                controlId="accountName"
                className={`${formik.errors.accountName ? 'is-invalid' : ''}`}
              >
                <Form.Label>Company Name</Form.Label>
                <TextInput
                  name="accountName"
                  value={formik.values.accountName}
                  className={`${formik.errors.accountName ? 'is-invalid' : ''}`}
                  onChange={formik.handleChange}
                  isInvalid={!!formik.errors.accountName}
                  validationMessage={formik.errors.accountName}
                />
              </Form.Group>
            </div>
          </div>
        </Form>
      </div>
    </Modal>
  );
}
